import { apiCall } from "@/common/api/ApiResult.model";
import { InformationType, InfoTypeHelper } from "@/common/models";
import { SharedState } from "@/common/state";
import { indexBy, isNotEmpty, path } from "@/fp";
import { PolicyL0StatusItem } from "./model";
import { to_query_params } from "@/utils/url";
import axios from "axios";
import { get_l0_labels_with_policies } from "@/common/api/labels.api";

const POLICY_KEY = "automaticJustification";

export const toggle_l0_policy_status = apiCall<
  { id: string; activate: boolean; selected_policy: string },
  boolean
>(
  "justification-policy.change-activate-for-l0",
  async ({ selected_policy, activate, id }) => {
    const policyValue = activate
      ? {
          id: selected_policy,
        }
      : null;
    const payload = [
      {
        id,
        policySection: {
          [POLICY_KEY]: {
            policyValue,
          },
        },
      },
    ];

    await axios.patch("/label-api", payload);
    return {
      success: true,
      value: true,
    };
  }
);

export const get_justification_policy_status_list = apiCall<
  void,
  PolicyL0StatusItem[]
>("justification-policy.list", async () => {
  let last_send_date = "";
  const res_send_date = await get_next_send_date();
  if (res_send_date.success) {
    last_send_date = res_send_date.value;
  }
  const res = await get_l0_labels_with_policies();
  if (res.success) {
    const fresh_l0 = indexBy<InformationType>("id")(res.value);
    console.log("fresh_l0: ", fresh_l0);
    const get_policy = InfoTypeHelper.get_policy(POLICY_KEY);
    return {
      success: true,
      value: SharedState.l0InfoTypes.value
        .filter((f) => f.id !== SharedState.default_label_id.value)
        .map((d) => {
          const policy = get_policy(fresh_l0[d.id]);
          return {
            id: d.id,
            name: d.labelName,
            order: d.l0Order,
            next_send_date: last_send_date,
            policy_id: policy || "high_severity",
            // @ts-ignore *  */
            is_active: isNotEmpty(policy),
          } as PolicyL0StatusItem;
        })
        // @ts-ignore
        .sort((a, b) => a.order - b.order),
    };
  } else {
    return { success: true, value: [] };
  }
});

const get_next_send_date_from_path = path(
  "value.maintenanceEntities.$0.nextApproximateUpdateAt",
  () => "?"
);

export const get_next_send_date = apiCall<void, string>(
  "risky-users.next-send-date",
  async () => {
    const qparams = to_query_params({
      scenarioId: "riskyUsers",
      entityType: "org",
      useOrgAsEntity: true,
    });
    const res = await axios.get(
      "/extproxy/integrations/maintenance-entities?" + qparams
    );

    return {
      success: true,
      value: get_next_send_date_from_path(res.data),
    };
  }
);
